import { SampleStatus } from '@caresend/types';
import { extractTarget } from '../../helpers/helpers.js';
import { getCommittedWorkflow, existingWorkflowMap, getWorkflowItemInitializer, maybeAddToMap, sortWorkflowByPriority } from '../helpers.js';
import { SampleWorkflowContextID, SampleWorkflowItemID } from './model.js';
import { WorkflowInlineComponentName } from '../model.js';

const getDefaultWorkflowItems = (sample, { procedures: __ }, procedureID) => {
    const workflow = getCommittedWorkflow(sample, procedureID, SampleWorkflowContextID.DEFAULT);
    const workflowMap = existingWorkflowMap(workflow);
    const priorities = {};
    const initWorkflowItem = getWorkflowItemInitializer(sample.id, 'samples', {
        context: SampleWorkflowContextID.DEFAULT,
        storeRef: 'procedures',
        referenceID: procedureID,
    });
    const sampleFillLevel = initWorkflowItem(SampleWorkflowItemID.SAMPLE_FILL_LEVEL, {
        component: {
            name: WorkflowInlineComponentName.TODO,
            props: {
                title: 'Sample fill level',
            },
        },
        after: {
            status: SampleStatus.COMPLETED,
        },
    });
    maybeAddToMap(sampleFillLevel, workflowMap);
    priorities[sampleFillLevel.id] = 1;
    /** TODO: Add more workflow items */
    return sortWorkflowByPriority(Array.from(workflowMap.values()), priorities);
};
const getSampleWorkflow = (s, contextID = 'default', procedureID, recordManagers) => {
    const { samples } = recordManagers;
    if (!samples)
        return [];
    const sample = extractTarget(s, samples.getRawClone);
    if (!sample)
        return [];
    switch (contextID) {
        case SampleWorkflowContextID.DEFAULT:
            return getDefaultWorkflowItems(sample, recordManagers, procedureID);
    }
    return [];
};

export { getSampleWorkflow };
